import { render, staticRenderFns } from "./WaysSummaryReport.vue?vue&type=template&id=4e1a2280"
import script from "./WaysSummaryReport.vue?vue&type=script&lang=js"
export * from "./WaysSummaryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports